import template from "./organization-new-card.html";

const OrganizationNewCardComponent = {
  bindings: {
    contact: "<",
    onSave: "&",
  },
  template: template,
  controller: class OrganizationNewCardController {
    /* @ngInject */
    constructor($rootScope, $scope, $state, $window, Organization, OrganizationService, moment) {
      this.$rootScope = $rootScope;
      this.$scope = $scope;
      this.$state = $state;
      this.$window = $window;
      this.Organization = Organization;
      this.OrganizationService = OrganizationService;
      this.moment = moment;
    }

    $onInit() {
      this.openedMoreData = false;
      this.timezoneGuessed = this.moment.tz.guess();
      this.currency = this.timezoneGuessed.includes("Europe") ? "EUR" : "USD";
      this.browserLanguage = this.$window.navigator.language.split("-")[0] === "es" ? "es" : "en";
      this.quoteLanguage = this.browserLanguage;
      this.organization = new this.Organization();
      this.saving = false;
    }

    setCurrency(oldCurrency, newCurrency) {
      if (!newCurrency) this.currency = oldCurrency;
      else this.currency = newCurrency;
    }

    setQuoteLanguage(oldQuoteLanguage, newQuoteLanguage) {
      this.quoteLanguage = !newQuoteLanguage ? oldQuoteLanguage : newQuoteLanguage;
    }

    showMoreData() {
      this.openedMoreData = !this.openedMoreData;
    }

    async createOrganization() {
      if (!this.form.$valid || !this.validCustomSector()) {
        return;
      }

      this.organization.settings = {
        appLanguage: this.browserLanguage,
        quoteLanguage: this.quoteLanguage,
        timezone: this.timezoneGuessed,
        currency: this.currency,
      };

      this.saving = true;
      const organization = await this.OrganizationService.createOrganization(this.organization);
      this.saving = false;
      this.$rootScope.$applyAsync();
      this.onSave({ organization });
    }
  },
};

export default OrganizationNewCardComponent;
